import { ResponsiveGrid } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import FixList from './components/FixList';

const { Cell } = ResponsiveGrid;

const Fix = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="報修列表"
        breadcrumbs={[
          {
            name: '報修服務',
          },
          {
            name: '報修列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <FixList />
    </Cell>
  </ResponsiveGrid>
);

export default Fix;
